<template>
  <v-data-table
    :headers="headers"
    :items="viajes"
    :search="search"
    :single-expand="true"
    :expanded.sync="expanded"
    sort-by="nombre"
    class="elevation-1"
    show-expand
    style="background: rgba(255, 255, 255, 0.7)"
  >
    <template #item.nro="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">{{ item.nro }}</span>
        </template>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th colspan="2">DETALLES</th>
              </tr>
            </thead>
            <tbody>
              <tr class="py-n5">
                <td class="text-caption">COMISIONADO</td>
                <td class="text-caption">
                  {{ item.comisionado_comisionado?.usuario_usuario?.nombre }}
                </td>
              </tr>
              <tr class="py-n5">
                <td class="text-caption">MOTIVO VIAJE</td>
                <td class="text-caption">{{ item.motivo }}</td>
              </tr>
              <tr class="py-n5">
                <td class="text-caption">CONEXION</td>
                <td class="text-caption">{{ item.ruta_viaje }}</td>
              </tr>
              <tr class="py-n5">
                <td class="text-caption">FINANCIAMIENTO</td>
                <td class="text-caption">
                  {{ item.financiamiento_financiamiento?.nombre }}
                </td>
              </tr>
              <tr class="py-n5">
                <td class="text-caption">TIPO VIAJE</td>
                <td class="text-caption">
                  {{
                    item.viaje_nacionals?.[0]?.region_nacional_region_nacional
                      ?.nombre
                  }}
                </td>
              </tr>
              <tr class="py-n5">
                <td class="text-caption">RESOLUCION</td>
                <td class="text-caption">
                  {{ item.resolucion_resolucion?.descripcion }}
                </td>
              </tr>
              <tr class="py-n5">
                <td class="text-caption">FIN DE SEMANA</td>
                <td class="text-caption">{{ item.fines_semana }}</td>
              </tr>
              <tr class="py-n5">
                <td class="text-caption">PROGRAMA</td>
                <td class="text-caption">
                  {{
                    item.comisionado_comisionado?.usuario_usuario
                      ?.oficina_oficina?.nombre
                  }}
                </td>
              </tr>
              <tr class="py-1">
                <td class="text-caption">TRANSPORTE</td>
                <td class="text-caption">
                  {{ item.transporte_transporte?.nombre }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-tooltip>
    </template>
    <template #item.total_viatico="{ item }">
      {{
        new Intl.NumberFormat("es-BO", { minimumFractionDigits: 2 }).format(
          item.total_viatico
        )
      }}
    </template>
    <template #item.tpasaje="{ item }">
      {{
        new Intl.NumberFormat("es-BO", { minimumFractionDigits: 2 }).format(
          item.tpasaje
        )
      }}
    </template>
    <template #item.fecha1="{ item }">
      {{ item.fecha1 }}
    </template>
    <template #item.fecha2="{ item }">
      {{ item.fecha2 }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="text-truncate">
        <v-tooltip
          bottom
          v-for="action in actions"
          :key="action.name"
          v-if="action.show(item)"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              icon
              class="mr-2"
              :color="action.color"
              v-bind="attrs"
              v-on="on"
              @click="$emit(action.event, item)"
            >
              <v-icon>{{ action.icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ action.label }}</span>
        </v-tooltip>
      </div>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="$emit('refresh')"> Refrescar </v-btn>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <slot name="expanded" :item="item" :headers="headers" />
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "ViajeTable",
  props: {
    headers: { type: Array, default: () => [] },
    viajes: { type: Array, default: () => [] },
    expanded: { type: Array, default: () => [] },
    search: { type: String, default: "" },
    actions: { type: Array, default: () => [] }, // [{ name, icon, color, label, event, show(item) }]
  },
};
</script>
